<template lang="pug">
.event-message
  .message-content(v-html="content")
  .message-date
    aiq-timeago(:since="messageDate" :maxTime="maxTime")
</template>

<script>
import BaseMessage from './BaseMessage/BaseMessage.vue';

export default {
  extends: BaseMessage,
  name: 'eventMessage',
};
</script>

<style lang="scss" scoped>
.event-message {
  display: flex;
  justify-content: center;
  margin: 20px 0;
  color: #99a9bf;
  font-size: 12px;
  line-height: 12px;
  font-weight: 300;
}

.message-date {
  margin-left: 20px;
}
</style>
